module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/zh-hant/6-0810c698373f77bab4b2c13ee9570f18.jpg";